module.exports = __webpack_public_path__ + "img/2.640ee39d.png";